var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
export var StepInfo = function (_a) {
    var _b;
    var formData = _a.formData, formFields = _a.formFields, onUpdate = _a.onUpdate, onSubmit = _a.onSubmit;
    var _c = useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var handleChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value, type = _b.type;
        var checked = e.target.checked;
        onUpdate((_a = {}, _a[name] = type === "checkbox" ? checked : value, _a));
    };
    var handleSelectChange = function (name, value) {
        var _a;
        onUpdate((_a = {}, _a[name] = value, _a));
    };
    // Check if all required fields are filled
    var isFormValid = formFields.requiredFields.every(function (fieldName) {
        var value = formData[fieldName];
        return value !== undefined && value !== null && value !== "";
    });
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!isFormValid)
                        return [2 /*return*/];
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onSubmit()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var renderField = function (field) {
        var _a;
        var fieldName = field.name;
        var value = formData[fieldName];
        switch (field.type) {
            case "text":
            case "email":
            case "tel":
                return (React.createElement("div", { key: field.name, className: "space-y-2" },
                    React.createElement(Label, { htmlFor: field.name },
                        field.label,
                        field.required && React.createElement("span", { className: "text-red-500" }, " *")),
                    React.createElement(Input, { id: field.name, name: field.name, type: field.type, value: String(value || ""), onChange: handleChange, required: field.required, placeholder: field.placeholder })));
            case "date":
                return (React.createElement("div", { key: field.name, className: "space-y-2" },
                    React.createElement(Label, { htmlFor: field.name },
                        field.label,
                        field.required && React.createElement("span", { className: "text-red-500" }, " *")),
                    React.createElement(Input, { id: field.name, name: field.name, type: "date", value: String(value || ""), onChange: handleChange, required: field.required })));
            case "textarea":
                return (React.createElement("div", { key: field.name, className: "space-y-2" },
                    React.createElement(Label, { htmlFor: field.name },
                        field.label,
                        field.required && React.createElement("span", { className: "text-red-500" }, " *")),
                    React.createElement(Textarea, { id: field.name, name: field.name, value: String(value || ""), onChange: handleChange, required: field.required, placeholder: field.placeholder, rows: 4 })));
            case "select":
                return (React.createElement("div", { key: field.name, className: "space-y-2" },
                    React.createElement(Label, { htmlFor: field.name },
                        field.label,
                        field.required && React.createElement("span", { className: "text-red-500" }, " *")),
                    React.createElement(Select, { value: String(value || field.default || ""), onValueChange: function (val) { return handleSelectChange(field.name, val); } },
                        React.createElement(SelectTrigger, null,
                            React.createElement(SelectValue, { placeholder: "Select ".concat(field.label.toLowerCase()) })),
                        React.createElement(SelectContent, null, (_a = field.options) === null || _a === void 0 ? void 0 : _a.map(function (option) { return (React.createElement(SelectItem, { key: option, value: option }, option)); })))));
            case "checkbox":
                return (React.createElement("div", { key: field.name, className: "flex items-center space-x-2" },
                    React.createElement(Checkbox, { id: field.name, name: field.name, checked: Boolean(value), onCheckedChange: function (checked) {
                            var _a;
                            return onUpdate((_a = {}, _a[fieldName] = !!checked, _a));
                        } }),
                    React.createElement(Label, { htmlFor: field.name, className: "text-sm font-normal" }, field.label)));
            default:
                return null;
        }
    };
    // Get step3 fields (Your Information)
    var step3Fields = ((_b = formFields.formFields.step3) === null || _b === void 0 ? void 0 : _b.fields) || [];
    return (React.createElement("form", { onSubmit: handleSubmit, className: "space-y-6 max-w-xl mx-auto" },
        React.createElement("div", { className: "grid grid-cols-1 sm:grid-cols-2 gap-4" }, step3Fields
            .filter(function (field) {
            return ["firstName", "lastName", "middleName"].includes(field.name);
        })
            .map(renderField)),
        step3Fields
            .filter(function (field) { return ["email", "phone"].includes(field.name); })
            .map(renderField),
        step3Fields.find(function (field) { return field.name === "preferredContactMethod"; }) && (React.createElement("div", { className: "space-y-2" },
            React.createElement(Label, null,
                "Preferred method of contact",
                formFields.requiredFields.includes("preferredContactMethod") && (React.createElement("span", { className: "text-red-500" }, " *"))),
            React.createElement(RadioGroup, { value: formData.preferredContactMethod, onValueChange: function (value) { return handleSelectChange("preferredContactMethod", value); }, className: "flex flex-col sm:flex-row sm:gap-8" },
                React.createElement("div", { className: "flex items-center space-x-2" },
                    React.createElement(RadioGroupItem, { value: "email", id: "r-email" }),
                    React.createElement(Label, { htmlFor: "r-email", className: "font-normal" }, "Email")),
                React.createElement("div", { className: "flex items-center space-x-2" },
                    React.createElement(RadioGroupItem, { value: "phone", id: "r-phone" }),
                    React.createElement(Label, { htmlFor: "r-phone", className: "font-normal" }, "Phone Call")),
                React.createElement("div", { className: "flex items-center space-x-2" },
                    React.createElement(RadioGroupItem, { value: "text", id: "r-text" }),
                    React.createElement(Label, { htmlFor: "r-text", className: "font-normal" }, "Text Message"))))),
        step3Fields
            .filter(function (field) {
            return ![
                "firstName",
                "lastName",
                "middleName",
                "email",
                "phone",
                "preferredContactMethod",
            ].includes(field.name);
        })
            .map(renderField),
        React.createElement(Button, { type: "submit", className: "w-full", size: "lg", disabled: !isFormValid || isSubmitting }, isSubmitting ? (React.createElement(React.Fragment, null,
            React.createElement(Loader2, { className: "mr-2 h-4 w-4 animate-spin" }),
            "Booking Your Tour...")) : ("Book Your Tour"))));
};
